<template>
  <v-dialog v-model="dialogIsVisible" max-width="500">
    <v-card>
      <v-card-actions>
        <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>
      </v-card-actions>
      
      <v-card-text>
        <h3 class="text-subtitle-1 mb-10">
          <b>Kopiera moment från:</b>
          <p>({{ copyElementsFromText }})</p>
        </h3>
  
        <TheCopyPasteElementList
          :items="items"
          @selected-items="selectItems($event)"
        />
  
        <TheProfessionList
          :reform="selectedReform"
          :selected-profession="getProfessionById(professionId)"
          @on-change="setProfession($event)"
        />
  
        <TheReformSelect
          :reform="selectedReform"
          @selected-reform="setReform($event)"
        />
  
        <TheCopyPasteCourseSelect
          :profession-id="computedProfessionId"
          :reform="reform"
          :profession-course="professionCourse"
          @selected-course="selectedCourse = $event"
        />
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn color="secondary" @click="$emit('close')">
          <v-icon>$sl-cancel</v-icon>Avbryt
        </v-btn>

        <v-btn class="icon" @click="onPaste()">
          <v-icon>$sl-check</v-icon>Klistra in
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import get from 'lodash/get'
import {RulesMixin} from '@/components/mixins'
import { mapGetters } from 'vuex'
import TheCopyPasteElementList from '@/components/dialog/copy-paste/TheCopyPasteElementList.vue'
import TheReformSelect from '@/components/dialog/copy-paste/TheReformSelect.vue'
import TheCopyPasteCourseSelect from '@/components/dialog/copy-paste/TheCopyPasteCourseSelect.vue'
import TheProfessionList from './TheProfessionList.vue'
import API from '@/services/api'

export default {
    name: 'TheCopyPasteDialog',

    mixins: [RulesMixin],

    components: {
      TheCopyPasteElementList,
      TheReformSelect,
      TheCopyPasteCourseSelect,
      TheProfessionList
    },

    props: {
      isVisible: {
        type: Boolean,
        default: false
      },
      items: {
        type: Array,
        default: () => ([])
      },
      professionId: {
        type: Number,
        required: true
      },
      professionCourse: {
        type: Object,
        default: () => ({})
      }
    },

    data: () => ({
      selectedElements: [],
      selectedCourse: null,
      reform: null,
      selectedProfessionId: 0
    }),

    computed: {
      ...mapGetters('basic', ['getProfessionById']),

      dialogIsVisible: {
        get() {
          return this.isVisible
        },
        set() {
          this.$emit('close')
        }
      },

      copyElementsFromText() {
        return `${this.getProfessionById(
          get(this, 'professionId', ''))?.name} - ${this.selectedReform} - ${get(this, 'professionCourse.courseName', ''
        )}`
      },

      selectedReform() {
        return get(this, 'professionCourse.reform', null) || 'Gy11'
      },
      
      computedProfessionId() {
        return this.selectedProfessionId || this.professionId
      }
    },

    methods: {
      get,

      async onPaste() {
        try {
          const courseId = get(this, 'selectedCourse.id', 0)

          const selectedGroupElements = get(this, 'selectedElements', []).filter(({ courseId }) => courseId === get(this, 'professionCourse.id', null))
          const elements = selectedGroupElements.map(element => {
            const { name, numSubElementsRequired, subElements } = element || {}
            if ( !name || !numSubElementsRequired ) return null
            return { courseId, name, numSubElementsRequired, subElements }
          }).filter(Boolean)

          await API.pasteElements({ data: { elements } })

          this.deleteAndUpdateCachedElements(selectedGroupElements)

          this.$emit('close')
          this.$emit('on-paste')

          this.$events.fire('showInfo', 'Klart!')
        } catch (error) {
          this.$events.fire('showError', 'Det har uppstått ett problem. Var god försök igen.')
        }
      },

      setReform(reform) {
        this.reform = reform
      },

      selectItems(items) {
        this.selectedElements = items
        this.$emit('selected-items', items)
      },

      setProfession(profession) {
        this.selectedProfessionId = profession.id
      },

      deleteAndUpdateCachedElements(elements = []) {
        const cachedElements = JSON.parse(sessionStorage.getItem('byn4_course_elements'))
        const elementIds = elements.map(({ id }) => id)
        if ( !cachedElements.length || !elementIds.length ) return
        const updatedCachedElements = cachedElements.filter(({ id }) => !elementIds.includes(id))
        this.$emit('selected-items', updatedCachedElements)
      }
    }
  };
</script>